import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { captureError } from '@clatter/platform';
import { NgPageTitle } from '../NgPageTitle/NgPageTitle';
import { EditableTextElementV2 } from '../../EditableTextElementV2/EditableTextElementV2';

interface NgEditablePageTitleProps {
  title: string;
  label?: string;
  isLoading: boolean;
  disableEdit?: boolean;
  onUpdate: (value: string) => Promise<void>;
}

const StyledTitleContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.small};
  min-height: 88px;
`;

const initialDisplayNameState = {
  isEditing: false,
  isLoading: false,
  errorMessage: '',
};

export const NgEditablePageTitle: FC<NgEditablePageTitleProps> = ({ title, disableEdit = false, label = 'Title', isLoading, onUpdate }) => {
  const [displayNameState, setDisplayNameState] = useState(initialDisplayNameState);

  const handleDisplayNameChange = async (action: { type: 'EDIT' | 'UPDATE' | 'CANCEL'; payload?: string }) => {
    if (action.type === 'EDIT') {
      setDisplayNameState((prev) => ({
        ...prev,
        isEditing: true,
      }));
      return;
    }

    if (action.type === 'CANCEL') {
      setDisplayNameState(initialDisplayNameState);
    }

    if (action.type === 'UPDATE') {
      setDisplayNameState((prev) => ({
        ...prev,
        isLoading: true,
      }));

      if (!action.payload) {
        captureError(new Error('Error updating display name: no value'), { component: 'NgEditablePageTitle', skipConsole: true });
        return;
      }

      try {
        await onUpdate(action.payload);

        setDisplayNameState(initialDisplayNameState);
      } catch (err: any) {
        captureError(err, { message: 'Error updating display name', component: 'NgEditablePageTitle' });

        setDisplayNameState((prev) => ({
          ...prev,
          errorMessage: 'Display name already exist.',
          isLoading: false,
        }));
      }
    }
  };

  return (
    <StyledTitleContainer>
      {/*@ts-ignore*/}
      <EditableTextElementV2
        element="h2"
        label={label}
        initialValue={title || 'Unknown'}
        onAction={handleDisplayNameChange}
        isLoading={displayNameState.isLoading || isLoading}
        errorMessage={displayNameState?.errorMessage}
        isEditing={displayNameState?.isEditing}
        disableEdit={disableEdit}
      >
        <NgPageTitle title={title} />
      </EditableTextElementV2>
    </StyledTitleContainer>
  );
};
